module.exports = __webpack_public_path__ + "img/academy-wizard.cfe56616.png";